import dayjs from "dayjs";

export const VIDEO_WINDOW_PADDING_SECONDS = 15;
export const VIDEO_SEGMENT_INTERVAL_SECONDS = 30;

export const clampToSegmentBoundary = (
  time: dayjs.Dayjs,
  direction: "floor" | "ceil"
): dayjs.Dayjs => {
  const seconds = time.second();
  const minutes = time.minute();

  const totalSeconds = minutes * 60 + seconds;
  const segmentIndex = Math[direction](
    totalSeconds / VIDEO_SEGMENT_INTERVAL_SECONDS
  );
  const clampedSeconds = segmentIndex * VIDEO_SEGMENT_INTERVAL_SECONDS;

  return time.startOf("hour").add(clampedSeconds, "seconds");
};

export type VideoWindow = Readonly<{
  startIso: string;
  endIso: string;
  videoStart: dayjs.Dayjs;
}>;

export const calculateVideoWindow = (
  startTime: dayjs.Dayjs,
  endTime: dayjs.Dayjs
): VideoWindow => {
  const videoStartWithPadding = startTime.subtract(
    VIDEO_WINDOW_PADDING_SECONDS,
    "seconds"
  );
  const videoEndWithPadding = endTime.add(
    VIDEO_WINDOW_PADDING_SECONDS,
    "seconds"
  );

  const videoStartTime = clampToSegmentBoundary(videoStartWithPadding, "floor");
  const videoEndTime = clampToSegmentBoundary(videoEndWithPadding, "ceil");

  return {
    startIso: videoStartTime.toISOString(),
    endIso: videoEndTime.toISOString(),
    videoStart: videoStartTime,
  };
};
